export default __webpack_public_path__ + "static/media/ils.379bcb48.png";